import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import React, { PureComponent } from "react"
import styles from "./styles"

let Layouts = {}

const layoutsReq = require.context(
  "./Layouts",
  true,
  /^\.\/[\w]+\/index\.(jsx?)$/im
)
layoutsReq.keys().forEach(key => {
  const compName = key.match(/^\.\/(\w+)\/index\.(jsx?)$/)[1]
  Layouts[compName] = layoutsReq(key).default
})

export let Blocks = {}

const blocksReq = require.context(
  "./Blocks",
  true,
  /^\.\/[\w]+\/index\.(jsx?)$/im
)
blocksReq.keys().forEach(key => {
  const compName = key.match(/^\.\/(\w+)\/index\.(jsx?)$/)[1]
  Blocks[compName] = blocksReq(key).default
})

class Template extends PureComponent {
  render() {
    const { classes, template, event } = this.props
    const Layout = Layouts[template.id]

    const getImageSrc = () => {
      if (
        event.digitalsign_image &&
        !event.digitalsign_image.endsWith("undefined")
      ) {
        // ensure .png extension
        let imageUrl = event.digitalsign_image.endsWith(".png")
          ? event.digitalsign_image
          : `${event.digitalsign_image}.png`

        // Add background removal if user set that setting
        if (
          !event.digitalsign_image_background &&
          imageUrl.includes("res.cloudinary.com")
        ) {
          // Insert e_bgremoval:screen transformation after /upload/
          imageUrl = imageUrl.replace(
            /\/upload\//,
            "/upload/e_bgremoval:screen/"
          )
        }

        return imageUrl
      }
      return "https://res.cloudinary.com/bidr/image/upload/v1717101684/WhiteNoTagline_nakbpt.png"
    }

    return Layout ? (
      <div className={classes.layout}>
        <div className={classes.topLine}>
          <Typography
            component="span"
            variant="h2"
            className={classes.auctionTitle}
          >
            {event.auction_title}
          </Typography>
        </div>
        <div className={classes.templateContainer}>
          <Layout blocks={template.blocks} event={event} />
        </div>
        <div className={classes.bottomLine}>
          {template.id === "TwoColumn" && (
            <Typography component="span" className={classes.instructions}>
              Thank you for your support! Please see staff/volunteers for
              assistance.
            </Typography>
          )}
          {template.id !== "TwoColumn" && (
            <Typography component="span" className={classes.instructions}>
              Text
              <Typography
                component="strong"
                variant="subtitle2"
                className={classes.instructionsBold}
              >
                {event.event_url}
              </Typography>
              to
              <Typography
                component="strong"
                variant="subtitle2"
                className={classes.instructionsBold}
              >
                {event.sms_number_display}
              </Typography>
              to join this event
            </Typography>
          )}
          <img className={classes.logo} src={getImageSrc()} />
          {/* <img
            className={classes.logo}
            src={
              event.digitalsign_image
                ? event.digitalsign_image
                : "https://res.cloudinary.com/bidr/image/upload/v1717101684/WhiteNoTagline_nakbpt.png"
            }
          /> */}
        </div>
      </div>
    ) : null
  }
}

export default withStyles(styles, { withTheme: true })(Template)



// WEBPACK FOOTER //
// ./src/components/Template/index.jsx